import { render, staticRenderFns } from "./RobotDetailDig.vue?vue&type=template&id=20727281&scoped=true"
import script from "./RobotDetailDig.vue?vue&type=script&lang=js"
export * from "./RobotDetailDig.vue?vue&type=script&lang=js"
import style0 from "./RobotDetailDig.vue?vue&type=style&index=0&id=20727281&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20727281",
  null
  
)

export default component.exports